module.exports = __webpack_public_path__ + "static/media/instagram.6697e9ba.svg";